import { CommonModule } from '@angular/common';
import { NotificationDialogComponent } from './notification-dialog.component';
import { MaterialModule } from 'src/@dva/shared/material-components.module';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, MaterialModule, TranslateModule],
  declarations: [NotificationDialogComponent],
  entryComponents: [NotificationDialogComponent],
  exports: [NotificationDialogComponent],
})
export class NotificationDialogModule {}
